
import { clearStatsCache } from './statsService.js';
import { clearVisitorCache } from '../services/visitorService.js';
import pubDevClient from './pubDevClient.js';

export function clearAllCaches() {
  clearStatsCache();
  clearVisitorCache();
  pubDevClient.clearCache();
}

export function getCacheStatus() {
  return {
    message: 'All services now use 5-minute caching with request deduplication',
    cacheSettings: {
      statsCache: '5 minutes',
      visitorCache: '5 minutes', 
      packageStatsCache: '5 minutes'
    },
    features: [
      'Request deduplication to prevent duplicate calls',
      'Automatic cache expiration',
      'Fallback data on API errors',
      'Debug logging for cache hits/misses'
    ]
  };
}

const cacheManager = {
  clearAllCaches,
  getCacheStatus
};

export default cacheManager;